import DisplayHeader from '../../components/display-header'

import Backbone from 'backbone'
import template from './scoring-types.hbs'
import scoringTypesRow from './scoring-types-row.hbs'
import DraggableList from 'draggable-list'
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'
import $ from 'jquery'
import _ from 'lodash'
import config from 'scoreboard/components/config'
import i18n from 'scoreboard/components/i18n'
import ScoringTypeModel from './scoring-type-model'
import ScoringTypeForm from './scoring-type-form'
import appDisplay from 'scoreboard/components/app-display'
import constants from 'scoreboard/components/constants'
const { UNSCORED } = constants
import DeleteConfirmation from 'scoreboard/components/delete-confirmation'
import errorHandler from 'scoreboard/components/error-handler'
import spotlight from 'scoreboard/components/spotlight'
import Tooltip from 'scoreboard/components/tooltip'
import highlight from 'scoreboard/components/highlight'
import { adminAppLink } from 'scoreboard/components/admin-link'
import scoringTypeIcon from 'scoreboard/components/scoring-type-icon'

/** The Admin | Scoring Types screen */
const ScoringTypes = Backbone.View.extend(/** @lends {ScoringTypes} */{

	className: 'admin admin-list-view table-hack display-layout',

	events: {
		'click .add': 'onClickAdd',
		'click .edit': 'onClickEdit',
		'click .delete': 'onClickDelete'
	},

	render: function() {
		this.$el.empty()
		this.renderDisplayHeader()
		this.$el.append(template())
		this.renderScoringTypes()
		this.renderDraggableList()
		return this
	},

	renderDisplayHeader: function() {
		_.invoke(this.displayHeader, 'remove')
		this.displayHeader = new DisplayHeader({
			heading: i18n.get('admin.appConfiguration.scoringTypes'),
			mobileGearHidden: true
		})
		this.$el.append(this.displayHeader.el)
		this.displayHeader.render()
	},

	renderScoringTypes: function() {
		let html = ''
		_.each(config.scoringTypes, scoringType => {
			let scoringTypeDescription = 'scorecards.node.metric.dataType.standard'
			if (scoringType.kpiValueType) {
				scoringTypeDescription =
					'admin.appConfiguration.scoringType.kpiValueType.' +
					scoringType.kpiValueType
			}
			html += scoringTypesRow({
				id: scoringType.id,
				unscored: scoringType.standardScoringType == UNSCORED,
				label: i18n.get(scoringType.label),
				subLabel: i18n.get(scoringTypeDescription),
				icon: scoringTypeIcon(scoringType),
				editable: _.isNil(scoringType.standardScoringType)
			})
		})
		this.$('.scoring-types').html(html)
	},

	renderDraggableList: function() {
		this.draggableList = new DraggableList(this.$('ul.scoring-types')[0])
		this.draggableList.on('move', this.reorder.bind(this))
		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })
	},

	reorder: function(node, newIndex, oldIndex) {
		var id = this.$(node).data('id')
		$.ajax({
			method: 'post',
			url: `api/admin/scoring-types/${id}/reorder?index=${newIndex}`,
			success: scoringTypes => config.scoringTypes = scoringTypes
		})
	},

	onClickAdd: function() {
		this.addOrEditScoringType()
	},

	onClickEdit: function(e) {
		this.addOrEditScoringType(this.getScoringType(e))
	},

	addOrEditScoringType: function(scoringType) {
		let form = new ScoringTypeForm({ model: scoringType })
		form.on('done', scoringType => {
			this.render()

			let el = this.$(`li[data-id=${scoringType.id}]`)
			el[0].scrollIntoView()
			spotlight(el)
		})
		appDisplay.dialog(form)
	},

	/**
	 * @returns {ScoringTypeModel}
	 */
	getScoringType: function(e) {
		let scoringTypeId = this.$(e.target).closest('[data-id]').data('id')
		return new ScoringTypeModel(config.scoringType(scoringTypeId))
	},

	onClickDelete: function(e) {
		let scoringType = this.getScoringType(e)
		if (scoringType.id == config.nonMetricScoringTypeId) {
			_.invoke(this.tooltip, 'remove')
			let content = i18n.get(
				'admin.appConfiguration.scoring.colors.cannotDelete',
				highlight(scoringType.get('label')),
				highlight(i18n.get('admin.appConfiguration.scoring.colors')),
				adminAppLink())
			this.tooltip = new Tooltip({
				attachTo: e.target,
				content
			}).render()
			return
		}

		let confirmation = new DeleteConfirmation({
			label: scoringType.get('label')
		})
		appDisplay.dialog(confirmation)
		confirmation.on('confirm', () => {
			this.performDelete(e)
			confirmation.trigger('done')
		})
	},

	performDelete: function(e) {
		let row = this.$(e.target).closest('[data-id]')
		let id = row.data('id')
		$.ajax({
			method: 'delete',
			url: `api/admin/scoring-types/${id}`,
			success: scoringTypes => config.scoringTypes = scoringTypes,
			error: xhr => {
				row.removeClass('is-not-displayed')
				errorHandler(xhr)
			}
		})
		row.addClass('is-not-displayed')
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.draggableList, this.covertButtonTooltips,
			this.tooltip, this.displayHeader], 'remove')
	}

})

export default ScoringTypes

ScoringTypes.__filename__ = 'admin/scoring-types/scoring-types.js'
